// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UploadLicense_upload_container__ckSjD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
}

.UploadLicense_text_field__cp7ng {
  width: 70%;
}
.UploadLicense_text_field_input__diRLq {
  margin: 0 !important;
}

.UploadLicense_cancel__H-kfK {
  margin-right: 20px !important;
}

.UploadLicense_confirm__umQ\\+C {
  margin-left: 0px !important;
}

.UploadLicense_file_box__mhDnI {
  margin: 0px 16px;
}

.UploadLicense_upload_file_btn_wrap__yBc1y {
  margin-right: 50px;
}

.UploadLicense_upload_btn__LPaVt {
  background-color: #283371 !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/UploadLicensePopup/UploadLicense.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":[".upload_container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: auto;\n}\n\n.text_field {\n  width: 70%;\n}\n.text_field_input {\n  margin: 0 !important;\n}\n\n.cancel {\n  margin-right: 20px !important;\n}\n\n.confirm {\n  margin-left: 0px !important;\n}\n\n.file_box {\n  margin: 0px 16px;\n}\n\n.upload_file_btn_wrap {\n  margin-right: 50px;\n}\n\n.upload_btn {\n  background-color: #283371 !important;\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upload_container": `UploadLicense_upload_container__ckSjD`,
	"text_field": `UploadLicense_text_field__cp7ng`,
	"text_field_input": `UploadLicense_text_field_input__diRLq`,
	"cancel": `UploadLicense_cancel__H-kfK`,
	"confirm": `UploadLicense_confirm__umQ+C`,
	"file_box": `UploadLicense_file_box__mhDnI`,
	"upload_file_btn_wrap": `UploadLicense_upload_file_btn_wrap__yBc1y`,
	"upload_btn": `UploadLicense_upload_btn__LPaVt`
};
export default ___CSS_LOADER_EXPORT___;
